import type { GetPaymentResponse } from "@jti/evo-client";
import type { PaymentData } from "@jti/fe-common";

export const getPaymentDataFromEvoResponse = (data?: GetPaymentResponse): PaymentData => ({
  status: data?.data?.status ?? "",
  order_id: data?.data?.order_id ?? 0,
  currency: data?.data?.currency ?? "",
  icon: data?.data?.method?.icon ?? "",
  payment_token: data?.data?.payment_token ?? "",
  title: data?.data?.method?.title ?? "",
  payment_method: data?.data?.method?.title ?? "",
  amount: data?.data?.amount ? String(data?.data?.amount) : "",
});
